import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/entity-pages/subpage/about-us/src/components/facts/assets/calendar.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')